module.exports = __webpack_public_path__ + "static/img/virusbanner.c40a7e3f.png";